import { render, staticRenderFns } from "./TvaNew.vue?vue&type=template&id=6a27c36b&"
import script from "./TvaNew.vue?vue&type=script&lang=js&"
export * from "./TvaNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a27c36b')) {
      api.createRecord('6a27c36b', component.options)
    } else {
      api.reload('6a27c36b', component.options)
    }
    module.hot.accept("./TvaNew.vue?vue&type=template&id=6a27c36b&", function () {
      api.rerender('6a27c36b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/tva/TvaNew.vue"
export default component.exports